(() => {
    const mainMenu = document.querySelector('[data-vd-component="main-menu"]');
    if (!mainMenu) return;

    const header = document.querySelector('[data-vd-component="header-section"]');
    const menuOverlay = document.querySelector(".menu-overlay");
    const items = Array.from(mainMenu.querySelectorAll(".menu-item"));
    let open = null;

    const openPanel = (panel, link) => {
        mainMenu.querySelectorAll(".menu-link.opened").forEach((el) => el.classList.remove("opened"));

        if (open && open !== panel) open.classList.remove("visible");
        panel.classList.add("visible");
        if (header) header.classList.add("menu-open");
        if (link) link.classList.add("opened");

        open = panel;
    };

    const closePanel = (panel) => {
        if (!panel) return;

        panel.classList.remove("visible");
        if (header) header.classList.remove("menu-open");
        mainMenu.querySelectorAll(".menu-link.opened").forEach((el) => el.classList.remove("opened"));
        if (open === panel) open = null;
    };
    const closeSubmenuOnly = (panel, link) => {
        if (!panel) return;
        panel.classList.remove("visible");
        link?.classList.remove("opened");
        if (open === panel) open = null;
    };

    const closeAll = () => {
        if (open) closePanel(open);
        if (header) header.classList.remove("menu-open");
        mainMenu.querySelectorAll(".menu-link.opened").forEach((el) => el.classList.remove("opened"));
    };

    const togglePanel = (panel, link) => {
        if (!panel) return;
        if (panel.classList.contains("visible")) closePanel(panel);
        else openPanel(panel, link);
    };
    const mq = window.matchMedia("(min-width: 90rem)");
    let ctrl = null;

    const bind = () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        const { signal } = ctrl;

        const isDesktop = mq.matches;

        // if (!isDesktop) closeAll();

        items.forEach((item) => {
            const linkWithChildren = item.querySelector(".menu-link.has-children");
            const panel = item.querySelector(".submenu-wrapper");
            const anyLink = item.querySelector(".menu-link");

            if (linkWithChildren && panel) {
                if (isDesktop) {
                    linkWithChildren.addEventListener("mouseenter", () => openPanel(panel, linkWithChildren), { signal });

                    panel.addEventListener("mouseleave", () => closePanel(panel), { signal });
                } else {
                    linkWithChildren.addEventListener(
                        "click",
                        (e) => {
                            e.preventDefault();
                            togglePanel(panel, linkWithChildren);
                        },
                        { signal },
                    );
                    const backBtn = panel.querySelector(".back-menu");
                    if (backBtn) {
                        backBtn.addEventListener(
                            "click",
                            (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                closeSubmenuOnly(panel, linkWithChildren);
                            },
                            { signal },
                        );
                    }
                }
            } else if (anyLink) {
                if (isDesktop) {
                    anyLink.addEventListener(
                        "mouseenter",
                        () => {
                            if (open) closePanel(open);
                        },
                        { signal },
                    );
                } else {
                    anyLink.addEventListener(
                        "click",
                        () => {
                            if (open) closePanel(open);
                        },
                        { signal },
                    );
                }
            }
        });
        if (isDesktop) {
            menuOverlay.addEventListener(
                "mouseenter",
                () => {
                    if (open) closePanel(open);
                },
                { signal },
            );
        }

        if (!isDesktop) {
            document.addEventListener(
                "click",
                (e) => {
                    if (!open) return;
                    if (mainMenu.contains(e.target)) return;
                    closePanel(open);
                },
                { signal },
            );

            document.addEventListener(
                "keydown",
                (e) => {
                    if (e.key === "Escape" && open) closePanel(open);
                },
                { signal },
            );
        }
    };

    bind();

    const onMqChange = () => {
        closeAll();
        bind();
    };

    if (mq.addEventListener) mq.addEventListener("change", onMqChange);
    else mq.addListener(onMqChange);
})();
